import importerStore from '@shared/importer/importer-store';
import { ProgramService } from '@modules/program/program-service';
import programImporterFields from '@modules/program/program-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  ProgramService.import,
  programImporterFields,
  i18n('entities.program.importer.fileName'),
  i18n('entities.program.importer.hint'),
);
